import { useContext } from 'react'
import { ApprovalCentreContext } from '@/components/approvals/ApprovalCentreProvider'

export function useApprovalCentre() {
  const context = useContext(ApprovalCentreContext)
  if (!context) throw new Error('useApprovalCentre must be used within ApprovalCentreProvider')
  return context
}
